import React, { FC } from 'react'
import { RadioGroupFieldV2 } from '@babylon/medkit'
import { useFormatMessage } from '@babylon/intl'

import formMessages from '@/components/FormRenderer/messages'
import { useConfig } from '@/redux/partnerConfig/selectors'
import { Field } from '@/types/partnerConfig'
import { RadioGroupWrapper } from '../Forms/FormElementWrappers'

type RadioProps = React.ComponentProps<typeof RadioGroupFieldV2>

type GenderProps = RadioProps & Field

const GenderField: FC<GenderProps> = ({
  name,
  onChange,
  label,
  ...props
}: GenderProps) => {
  const translate = useFormatMessage()
  const { useDnaV2Design } = useConfig()

  const options: RadioProps['options'] = [
    {
      label: translate(formMessages.genderMale),
      value: 'male',
    },
    {
      label: translate(formMessages.genderFemale),
      value: 'female',
    },
  ]

  if (useDnaV2Design) {
    return (
      <RadioGroupWrapper
        {...props}
        name={name}
        options={options}
        label={label}
      />
    )
  }

  return <RadioGroupFieldV2 {...props} name={name} options={options} />
}

export default GenderField
